import { render, staticRenderFns } from "./BusinessOnboarding.vue?vue&type=template&id=4b871fa5&scoped=true&"
import script from "./BusinessOnboarding.vue?vue&type=script&lang=ts&"
export * from "./BusinessOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessOnboarding.vue?vue&type=style&index=0&id=4b871fa5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b871fa5",
  null
  
)

export default component.exports